import { render, staticRenderFns } from "./AuthFailures.vue?vue&type=template&id=3884c3da&scoped=true"
import script from "./AuthFailures.vue?vue&type=script&lang=js"
export * from "./AuthFailures.vue?vue&type=script&lang=js"
import style0 from "./AuthFailures.vue?vue&type=style&index=0&id=3884c3da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3884c3da",
  null
  
)

export default component.exports